import { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, Form, Button, Spinner, ListGroup, Badge } from 'react-bootstrap';
import {
  FiSend,
  FiCopy,
  FiCheck,
  FiLoader,
  FiLink,
  FiDownload,
  FiRotateCcw,
  FiImage,
  FiX,
  FiEdit,
  FiUpload,
  FiHash,
  FiTarget,
} from 'react-icons/fi';
import { MdOutlinePostAdd } from 'react-icons/md';
import {
  BsStars,
  BsThreads,
  BsChatSquareText,
  BsPencilSquare,
  BsBook,
  BsBriefcase,
  BsEmojiSmile,
  BsPeople,
  BsRocket,
  BsEmojiLaughing,
  BsFire,
} from 'react-icons/bs';
import { RiFileListLine } from 'react-icons/ri';
import { AiOutlineYoutube } from 'react-icons/ai';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// TODO: এখানে আপনার নিজের backend সার্ভারের URL বসান
const API_ENDPOINT = 'https://img.hrlimon.com/api/social-media-post-generator';

const brand = {
  red: '#ff5266',
  orange: '#ff9a3e',
};

export default function SocialMediaPostGenerator() {
  const [activeTab, setActiveTab] = useState('step-guide');
  const [input, setInput] = useState('');
  const [urlInput, setUrlInput] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [tone, setTone] = useState('informational');
  const [output, setOutput] = useState(null);
  const [loading, setLoading] = useState(false);
  const [copiedAll, setCopiedAll] = useState(false);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const dropZoneRef = useRef(null);

  const postTypes = [
    {
      id: 'step-guide',
      name: 'Step-by-Step Guide',
      icon: RiFileListLine,
      description: 'Create detailed guideline posts',
      placeholder: 'Enter your topic (e.g., How to create viral reels)',
      supportsImage: true,
      examples: [
        'ফ্রিল্যান্সিং শুরু করার ৭টি টিপস',
        'ChatGPT দিয়ে কনটেন্ট লেখার সহজ উপায়',
        'AI টুলস দিয়ে আয় করার কৌশল',
      ],
    },
    {
      id: 'link-viral',
      name: 'Link to Viral Post',
      icon: FiLink,
      description: 'Convert any URL into viral content',
      placeholder: 'Paste URL here...',
      requiresUrl: true,
      supportsImage: false,
      examples: [
        'https://hrlimon.com/blog/20-gemini-prompts-turn-sketches-into-illustrations',
        'https://www.bbc.com/bengali',
        'https://youtube.com/watch?v=example',
      ],
    },
    {
      id: 'thread',
      name: 'Thread Post',
      icon: BsThreads,
      description: 'Generate engaging thread posts',
      placeholder: 'Enter thread topic...',
      supportsImage: true,
      examples: [
        'AI টুলস নিয়ে ৭টি গেম চেঞ্জিং টিপস',
        'ডিজিটাল মার্কেটিং এ সফল হওয়ার উপায়',
        'ChatGPT এর হিডেন ফিচার',
      ],
    },
    {
      id: 'status',
      name: 'Status Post',
      icon: BsChatSquareText,
      description: 'Create short status updates',
      placeholder: "What's on your mind?",
      supportsImage: true,
      examples: [
        'আজকের AI আপডেট নিয়ে চমকপ্রদ তথ্য',
        'সোশ্যাল মিডিয়া মার্কেটিং টিপস',
        'ফ্রিল্যান্সিং ক্যারিয়ার নিয়ে পরামর্শ',
      ],
    },
    {
      id: 'refine',
      name: 'Refine Post',
      icon: BsPencilSquare,
      description: 'Rewrite posts in your style',
      placeholder: 'Paste the post you want to refine...',
      supportsImage: true,
      examples: ['[Paste any post to refine]', "[Copy competitor's post]", '[Old post to update]'],
    },
    {
      id: 'faceless-insight',
      name: 'Faceless Channel Insight',
      icon: AiOutlineYoutube,
      description: 'Analyze YouTube channels',
      placeholder: 'Paste YouTube channel URL or describe...',
      supportsImage: true,
      examples: [
        'https://youtube.com/@examplechannel',
        'Analyze this faceless channel screenshot',
        'YouTube channel data analysis',
      ],
    },
    {
      id: 'bangla-polisher',
      name: 'Bangla Content Polisher',
      icon: BsStars,
      description: 'Polish raw text to Bengali',
      placeholder: 'Paste your raw content (any language)...',
      supportsImage: false,
      examples: ['today was good day i learned many', 'আজকে অনেক ভালো লাগছে মন', 'Finally completed my AI project'],
    },
  ];

  const tones = [
    { value: 'informational', label: 'Informational', icon: BsBook },
    { value: 'professional', label: 'Professional', icon: BsBriefcase },
    { value: 'casual', label: 'Casual', icon: BsEmojiSmile },
    { value: 'friendly', label: 'Friendly', icon: BsPeople },
    { value: 'motivational', label: 'Motivational', icon: BsRocket },
    { value: 'humorous', label: 'Humorous', icon: BsEmojiLaughing },
  ];

  const currentType = postTypes.find((t) => t.id === activeTab);

  const processImageFile = (file) => {
    if (file && file.type.startsWith('image/')) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      alert('Please upload a valid image file');
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) processImageFile(file);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      processImageFile(files[0]);
    }
  };

  useEffect(() => {
    const handlePaste = (e) => {
      const items = e.clipboardData?.items;
      if (!items) return;

      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          const file = items[i].getAsFile();
          if (file) {
            processImageFile(file);
            e.preventDefault();
          }
        }
      }
    };

    if (currentType?.supportsImage) {
      document.addEventListener('paste', handlePaste);
      return () => document.removeEventListener('paste', handlePaste);
    }
  }, [currentType]);

  const removeImage = () => {
    setImageFile(null);
    setImagePreview(null);
  };

  const handleGenerate = async () => {
    const currentInput = currentType?.requiresUrl ? urlInput : input;
    if (!currentInput.trim() && !imageFile) return;

    setLoading(true);
    setOutput(null);

    try {
      let imageBase64 = null;
      if (imageFile) {
        const reader = new FileReader();
        imageBase64 = await new Promise((resolve) => {
          reader.onloadend = () => resolve(reader.result.split(',')[1]);
          reader.readAsDataURL(imageFile);
        });
      }

      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          postType: activeTab,
          input: currentInput.trim(),
          tone,
          image: imageBase64,
        }),
      });

      if (!response.ok) throw new Error('Failed to generate');

      const data = await response.json();
      setOutput(data.output);
    } catch (error) {
      alert('Error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCopyAll = () => {
    const fullText =
      output.hook +
      '\n\n' +
      output.posts.map((p) => `${p.number} ${p.content}`).join('\n\n') +
      (output.cta ? '\n\n' + output.cta : '') +
      (output.bonus ? '\n\n' + output.bonus : '') +
      (output.hashtags ? '\n\n' + output.hashtags : '') +
      (output.signature ? '\n\n' + output.signature : '');
    navigator.clipboard.writeText(fullText);
    setCopiedAll(true);
    setTimeout(() => setCopiedAll(false), 2000);
  };

  const handleCopyPost = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 2000);
  };

  const handleDownload = () => {
    const fullText =
      output.hook +
      '\n\n' +
      output.posts.map((p) => `${p.number} ${p.content}`).join('\n\n') +
      (output.cta ? '\n\n' + output.cta : '') +
      (output.bonus ? '\n\n' + output.bonus : '') +
      (output.hashtags ? '\n\n' + output.hashtags : '') +
      (output.signature ? '\n\n' + output.signature : '');
    const blob = new Blob([fullText], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `social-media-post-${Date.now()}.txt`;
    a.click();
  };

  const handleReset = () => {
    setOutput(null);
    setInput('');
    setUrlInput('');
    setImageFile(null);
    setImagePreview(null);
  };

  return (
    <div className="bg-white rounded-4">
            <Row className="g-4 align-items-start">
        {/* Left Sidebar */}
        <Col xs={4} lg={3}>
          <Card className="shadow border-0 p-3 sticky-top" style={{ top: 24 }}>
            <Card.Body>
              <h2 className="fs-6 fw-bold d-flex align-items-center gap-2 mb-3">
                <BsStars color={brand.red} /> Post Categories
              </h2>
              <ListGroup variant="flush" className="d-flex flex-column gap-2">
                {postTypes.map((type) => {
                  const Icon = type.icon;
                  const isActive = activeTab === type.id;
                  return (
                    <ListGroup.Item
                      key={type.id}
                      action
                      onClick={() => {
                        setActiveTab(type.id);
                        setInput('');
                        setUrlInput('');
                        setImageFile(null);
                        setImagePreview(null);
                        setOutput(null);
                      }}
                      className="rounded-3 border-0"
                      style={
                        isActive
                          ? { background: `linear-gradient(to right, ${brand.red}, ${brand.orange})`, color: '#fff' }
                          : { backgroundColor: '#f8f9fa', color: '#495057' }
                      }
                    >
                      <div className="d-flex align-items-center gap-2">
                        <Icon size={20} className="flex-shrink-0" />
                        <div className="flex-grow-1">
                          <div className="fw-semibold small">{type.name}</div>
                          <div
                            className="small"
                            style={{ fontSize: '0.7rem', color: isActive ? 'rgba(255,255,255,0.8)' : '#868e96' }}
                          >
                            {type.description}
                          </div>
                        </div>
                      </div>
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>

               {/* Right Content Area */}
        <Col xs={8} lg={9}>
          {/* Input Section */}
          <Card className="shadow-lg border-0 p-4 mb-4">
            <Card.Body>
              {/* Quick Examples */}
              <div className="mb-4">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <BsStars color={brand.red} />
                  <h3 className="fs-6 fw-bold mb-0">Quick Examples</h3>
                  <span className="small text-muted ms-2">Click to use</span>
                </div>
                <Row className="g-2">
                  {currentType?.examples.map((example, idx) => (
                    <Col md={4} sm={6} key={idx}>
                      <Button
                        variant="light"
                        className="w-100 text-start small border h-100"
                        onClick={() => {
                          if (currentType?.requiresUrl) {
                            setUrlInput(example);
                          } else {
                            setInput(example);
                          }
                        }}
                      >
                        {example}
                      </Button>
                    </Col>
                  ))}
                </Row>
              </div>

              {/* Main Input */}
              {currentType?.requiresUrl ? (
                <div className="mb-4">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div className="p-2 rounded-3" style={{ backgroundColor: 'rgba(255,82,102,0.1)' }}>
                      <FiLink size={20} color={brand.red} />
                    </div>
                    <div>
                      <h2 className="fs-5 fw-bold mb-0">Enter URL</h2>
                      <p className="small text-muted mb-0">Paste any link to convert</p>
                    </div>
                  </div>
                  <Form.Control
                    type="url"
                    value={urlInput}
                    onChange={(e) => setUrlInput(e.target.value)}
                    placeholder={currentType.placeholder}
                    disabled={loading}
                  />
                </div>
              ) : (
                <div className="mb-4">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div className="p-2 rounded-3" style={{ backgroundColor: 'rgba(255,82,102,0.1)' }}>
                      <MdOutlinePostAdd size={20} color={brand.red} />
                    </div>
                    <div>
                      <h2 className="fs-5 fw-bold mb-0">Enter Your Content</h2>
                      <p className="small text-muted mb-0">Describe your topic or paste content</p>
                    </div>
                  </div>
                  <Form.Control
                    as="textarea"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder={currentType?.placeholder}
                    rows={5}
                    style={{ resize: 'none' }}
                    disabled={loading}
                  />
                </div>
              )}

              {/* Image Upload */}
              {currentType?.supportsImage && (
                <div className="mb-4">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div className="p-2 rounded-3" style={{ backgroundColor: 'rgba(255,82,102,0.1)' }}>
                      <FiImage size={20} color={brand.red} />
                    </div>
                    <div>
                      <h3 className="fs-6 fw-bold mb-0">Upload Image</h3>
                      <p className="small text-muted mb-0">Optional • Drag & Drop • Paste (Ctrl+V)</p>
                    </div>
                  </div>

                  {!imagePreview ? (
                    <div
                      ref={dropZoneRef}
                      onDragEnter={handleDragEnter}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      className="position-relative d-flex flex-column align-items-center justify-content-center rounded-3"
                      style={{
                        height: 160,
                        border: `2px dashed ${isDragging ? brand.red : '#ced4da'}`,
                        backgroundColor: isDragging ? 'rgba(255,82,102,0.1)' : '#f8f9fa',
                        cursor: 'pointer',
                      }}
                    >
                      <Form.Label className="d-flex flex-column align-items-center justify-content-center w-100 h-100 m-0" style={{ cursor: 'pointer' }}>
                        {isDragging ? (
                          <>
                            <FiUpload size={36} color={brand.red} className="mb-2" />
                            <span className="fw-bold" style={{ color: brand.red }}>
                              Drop here!
                            </span>
                          </>
                        ) : (
                          <>
                            <FiImage size={30} color="#adb5bd" className="mb-2" />
                            <span className="small fw-medium text-secondary">Click or drag & drop</span>
                            <span className="small text-muted mt-1">JPG, PNG, WebP</span>
                          </>
                        )}
                        <Form.Control type="file" accept="image/*" onChange={handleImageUpload} className="d-none" disabled={loading} />
                      </Form.Label>
                    </div>
                  ) : (
                    <div className="position-relative d-inline-block">
                      <img
                        src={imagePreview}
                        alt="Preview"
                        className="rounded-3 shadow"
                        style={{ maxHeight: 240, border: `4px solid ${brand.red}` }}
                      />
                      <Button
                        variant="danger"
                        onClick={removeImage}
                        className="position-absolute rounded-circle d-flex align-items-center justify-content-center p-0"
                        style={{ top: -12, right: -12, width: 36, height: 36 }}
                      >
                        <FiX size={18} />
                      </Button>
                      <div
                        className="position-absolute d-flex align-items-center gap-1 px-2 py-1 rounded-2 small fw-bold text-white"
                        style={{ bottom: 12, left: 12, background: `linear-gradient(to right, ${brand.red}, ${brand.orange})` }}
                      >
                        <FiCheck /> Ready
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Tone Selector */}
              <div className="mb-4">
                <Form.Label className="fw-bold">Select Tone</Form.Label>
                <Form.Select value={tone} onChange={(e) => setTone(e.target.value)} disabled={loading}>
                  {tones.map((t) => (
                    <option key={t.value} value={t.value}>
                      {t.label}
                    </option>
                  ))}
                </Form.Select>
              </div>

              {/* Generate Button */}
              <Button
                onClick={handleGenerate}
                disabled={loading || ((!input.trim() && !urlInput.trim()) && !imageFile)}
                className="w-100 py-3 fw-bold border-0 d-flex align-items-center justify-content-center gap-2"
                style={{ background: `linear-gradient(to right, ${brand.red}, ${brand.orange})`, color: '#fff', fontSize: '1.05rem' }}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" /> Generating...
                  </>
                ) : (
                  <>
                    <FiSend size={20} /> Generate {currentType?.name}
                  </>
                )}
              </Button>
            </Card.Body>
          </Card>

          {/* Output Section */}
          {output && (
            <div>
              {/* Action Buttons */}
              <Card className="shadow border-0 p-3 mb-4">
                <Card.Body className="d-flex align-items-center justify-content-between flex-wrap gap-3 py-0">
                  <h2 className="fs-5 fw-bold d-flex align-items-center gap-2 mb-0">
                    <BsStars color={brand.red} /> Generated Content
                  </h2>
                  <div className="d-flex gap-2 flex-wrap">
                    <Button
                      onClick={handleCopyAll}
                      className="d-flex align-items-center gap-2 border-0 fw-semibold"
                      style={{ background: `linear-gradient(to right, ${brand.red}, ${brand.orange})`, color: '#fff' }}
                    >
                      {copiedAll ? <FiCheck /> : <FiCopy />}
                      <span>{copiedAll ? 'Copied!' : 'Copy All'}</span>
                    </Button>
                    <Button variant="dark" onClick={handleDownload} className="d-flex align-items-center gap-2 fw-semibold">
                      <FiDownload />
                      <span>Download</span>
                    </Button>
                    <Button variant="outline-danger" onClick={handleReset} className="d-flex align-items-center gap-2 fw-semibold">
                      <FiRotateCcw />
                      <span>Reset</span>
                    </Button>
                  </div>
                </Card.Body>
              </Card>

              {/* Hook Post */}
              {output.hook && (
                <Card className="border-0 shadow-lg mb-4 text-white" style={{ background: `linear-gradient(to right, ${brand.red}, ${brand.orange})` }}>
                  <Card.Body>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center gap-2">
                        <FiTarget size={24} />
                        <span className="fw-bold fs-5">Hook Options</span>
                      </div>
                      <Button
                        variant="light"
                        onClick={() => handleCopyPost(output.hook, 'hook')}
                        className="d-flex align-items-center gap-2 fw-semibold"
                        style={{ color: brand.red }}
                      >
                        {copiedIndex === 'hook' ? <FiCheck /> : <FiCopy />}
                        <span>{copiedIndex === 'hook' ? 'Copied!' : 'Copy'}</span>
                      </Button>
                    </div>
                    <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                      {output.hook}
                    </p>
                  </Card.Body>
                </Card>
              )}

              {/* Posts */}
              {output.posts &&
                output.posts.map((post, idx) => (
                  <Card key={idx} className="border-0 shadow mb-3" style={{ borderLeft: `4px solid ${brand.red}` }}>
                    <Card.Body>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            className="d-flex align-items-center justify-content-center rounded-3 text-white fw-bold fs-5"
                            style={{ width: 48, height: 48, background: `linear-gradient(to bottom right, ${brand.red}, ${brand.orange})` }}
                          >
                            {post.number}
                          </div>
                          <span className="small text-muted fw-semibold">Post {idx + 1}</span>
                        </div>
                        <Button
                          variant="outline-danger"
                          onClick={() => handleCopyPost(post.content, idx)}
                          className="d-flex align-items-center gap-2 fw-semibold"
                        >
                          {copiedIndex === idx ? <FiCheck /> : <FiCopy />}
                          <span>{copiedIndex === idx ? 'Copied!' : 'Copy'}</span>
                        </Button>
                      </div>
                      <p className="mb-0" style={{ whiteSpace: 'pre-wrap', color: '#343a40' }}>
                        {post.number} {post.content}
                      </p>
                    </Card.Body>
                  </Card>
                ))}

              {/* CTA */}
              {output.cta && (
                <Card className="border-0 shadow-lg mb-3 text-white" style={{ background: 'linear-gradient(to right, #3b82f6, #9333ea)' }}>
                  <Card.Body>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <div className="d-flex align-items-center gap-2">
                        <FiTarget size={24} />
                        <span className="fw-bold fs-5">Call to Action</span>
                      </div>
                      <Button
                        variant="light"
                        onClick={() => handleCopyPost(output.cta, 'cta')}
                        className="d-flex align-items-center gap-2 fw-semibold"
                        style={{ color: '#2563eb' }}
                      >
                        {copiedIndex === 'cta' ? <FiCheck /> : <FiCopy />}
                        <span>{copiedIndex === 'cta' ? 'Copied!' : 'Copy'}</span>
                      </Button>
                    </div>
                    <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                      {output.cta}
                    </p>
                  </Card.Body>
                </Card>
              )}

              {/* Bonus */}
              {output.bonus && (
                <Card className="border-0 shadow-lg mb-3 text-white" style={{ background: 'linear-gradient(to right, #facc15, #f97316)' }}>
                  <Card.Body>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <div className="d-flex align-items-center gap-2">
                        <BsFire size={24} />
                        <span className="fw-bold fs-5">Bonus Tips</span>
                      </div>
                      <Button
                        variant="light"
                        onClick={() => handleCopyPost(output.bonus, 'bonus')}
                        className="d-flex align-items-center gap-2 fw-semibold"
                        style={{ color: '#ea580c' }}
                      >
                        {copiedIndex === 'bonus' ? <FiCheck /> : <FiCopy />}
                        <span>{copiedIndex === 'bonus' ? 'Copied!' : 'Copy'}</span>
                      </Button>
                    </div>
                    <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                      {output.bonus}
                    </p>
                  </Card.Body>
                </Card>
              )}

              {/* Hashtags */}
              {output.hashtags && (
                <Card className="border-0 shadow-lg mb-3 text-white" style={{ background: 'linear-gradient(to right, #4ade80, #06b6d4)' }}>
                  <Card.Body>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <div className="d-flex align-items-center gap-2">
                        <FiHash size={24} />
                        <span className="fw-bold fs-5">Hashtags</span>
                      </div>
                      <Button
                        variant="light"
                        onClick={() => handleCopyPost(output.hashtags, 'hashtags')}
                        className="d-flex align-items-center gap-2 fw-semibold"
                        style={{ color: '#16a34a' }}
                      >
                        {copiedIndex === 'hashtags' ? <FiCheck /> : <FiCopy />}
                        <span>{copiedIndex === 'hashtags' ? 'Copied!' : 'Copy'}</span>
                      </Button>
                    </div>
                    <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                      {output.hashtags}
                    </p>
                  </Card.Body>
                </Card>
              )}

              {/* Signature */}
              {output.signature && (
                <Card className="border-0 shadow-lg text-white" style={{ background: `linear-gradient(to right, ${brand.red}, ${brand.orange})` }}>
                  <Card.Body>
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                      <div className="d-flex align-items-center gap-3 flex-grow-1">
                        <div className="p-3 rounded-3" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                          <FiEdit size={28} />
                        </div>
                        <div className="flex-grow-1">
                          <h3 className="fw-bold fs-5 mb-2">Author Signature</h3>
                          <p className="mb-0 small" style={{ whiteSpace: 'pre-wrap', opacity: 0.95 }}>
                            {output.signature}
                          </p>
                        </div>
                      </div>
                      <Button
                        variant="light"
                        onClick={() => handleCopyPost(output.signature, 'signature')}
                        className="d-flex align-items-center gap-2 fw-semibold"
                        style={{ color: brand.red }}
                      >
                        {copiedIndex === 'signature' ? <FiCheck /> : <FiCopy />}
                        <span>{copiedIndex === 'signature' ? 'Copied!' : 'Copy'}</span>
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              )}
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
}